var map = {
	"./ar/Customers": 3247,
	"./ar/Customers.js": 3247,
	"./ar/Exams": 1214,
	"./ar/Exams.js": 1214,
	"./ar/Notifications": 5338,
	"./ar/Notifications.js": 5338,
	"./ar/Plans": 9626,
	"./ar/Plans.js": 9626,
	"./ar/Products": 2924,
	"./ar/Products.js": 2924,
	"./ar/Profile": 4127,
	"./ar/Profile.js": 4127,
	"./ar/Samples": 2581,
	"./ar/Samples.js": 2581,
	"./ar/SpecialtyVisitMaterials": 2189,
	"./ar/SpecialtyVisitMaterials.js": 2189,
	"./ar/Visits": 7296,
	"./ar/Visits.js": 7296,
	"./en/Customers": 8463,
	"./en/Customers.js": 8463,
	"./en/Exams": 9598,
	"./en/Exams.js": 9598,
	"./en/Notifications": 5018,
	"./en/Notifications.js": 5018,
	"./en/Plans": 1914,
	"./en/Plans.js": 1914,
	"./en/Products": 1948,
	"./en/Products.js": 1948,
	"./en/Profile": 8399,
	"./en/Profile.js": 8399,
	"./en/Samples": 4949,
	"./en/Samples.js": 4949,
	"./en/SpecialtyVisitMaterials": 9757,
	"./en/SpecialtyVisitMaterials.js": 9757,
	"./en/Visits": 9200,
	"./en/Visits.js": 9200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5241;